// extracted by mini-css-extract-plugin
export default {"title":"contact_title__fg0cE","contactBlock":"contact_contactBlock__Xo6HI","contact":"contact_contact__kHd2V"};